/* The Proposal Box Collection - box product page behaviour (loaded by bbox-pdp-top.liquid).
   Works on top of the store's design-fields form (snippets/pr-design-fields.liquid + pr-design-fields.js):
   1. Short dropdowns (3 choices or fewer) become choice buttons; "Robe color" becomes colour dots.
      The real <select> stays in the form (hidden) so the order still gets properties[...] as before.
   2. Lid preview: "Will you be my <role>, <name>?" follows the form.
   3. "Add & personalize the next bridesmaid": adds the box to the cart without leaving the page, confirms it
      at the top of the form, then clears the per-girl fields (name, role, sizes, letter, photos, captions,
      clutch text) and keeps the shared picks.
   4. A sticky bar on phones whenever the real Add to cart button is off screen: "Personalize her box" (jumps
      to the form) while the form is still below the screen, "Add to cart" (submits; missing fields get
      highlighted by the form's own guard) once the form is on screen or has scrolled past. */
(function () {
  var ROBE = { Blush: '#f3cfc6', Black: '#1a1a1a', Burgundy: '#6b1f2b', Champagne: '#e9d6b8', Charcoal: '#555555', Eggplant: '#4a2a4f',
    'Hot Pink': '#e63e8c', Ivory: '#f6f1e7', Lavender: '#c9b7e2', 'Navy Blue': '#1f2a5a', Red: '#b8202a', "Robin's Egg Blue": '#9fd3d6',
    'Royal Blue': '#2b4fb0', Sage: '#a8b89a', Teal: '#2a7f80', White: '#ffffff', 'Dusty Rose': '#d4a1a1', Emerald: '#0f6b4a',
    Silver: '#c9c9c9', Gold: '#d4af37', Pink: '#f4b6c8', Coral: '#f08070', Mint: '#b6e3cf', Lilac: '#c9aee0', Grey: '#9a9a9a', Gray: '#9a9a9a' };
  // fields emptied for the next girl (matched on the label text, lower-case, "starts with")
  /* robe text colours = the satin robe page's "Text Color" swatches (pr-main-product1) */
  var TEXTCOL = { 'Gold Matte': '#c9a96e', 'Gold Metallic': 'linear-gradient(135deg,#d4af37,#f5d97a,#d4af37)', 'Rose Gold': 'linear-gradient(135deg,#b76e79,#e8c4c4,#b76e79)',
    'Silver Metallic': 'linear-gradient(135deg,#a8a8a8,#e0e0e0,#a8a8a8)', 'White': '#f8f8f8', 'Ivory': '#f1e7d0', 'Champagne': '#e8d5a3', 'Black': '#111111', 'Charcoal': '#4a4a4a',
    'Blush Pink': '#e8a0a0', 'Hot Pink': '#d45888', 'Coral': '#e98974', 'Red': '#c0392b', 'Burgundy': '#7a2438', 'Orange': '#e67e22', 'Yellow': '#f1c40f', 'Mint': '#a8e0c4',
    'Sage Green': '#a8b89a', 'Emerald': '#1e7a52', 'Hunter Green': '#2f4f2f', 'Baby Blue': '#a9cce3', "Robin's Egg Blue": '#82c8d4', 'Teal': '#2a7f7f', 'Royal Blue': '#2a4ea6' };
  /* Weekend Kit sweatshirt colours (the colours the site's sweatshirt listings state) */
  var SWEAT = { 'White': '#f8f8f8', 'Black': '#111111', 'Dark Heather': '#4b4b50', 'Forest Green': '#2f4f2f', 'Irish Green': '#3fa34d', 'Maroon': '#6d1f2f', 'Navy': '#1b2a4a', 'Red': '#c0392b' };
  function colorsFor(label) { // any "...colour" choice is drawn as colour dots; pick the matching palette
    if (/^robe text/i.test(label)) return TEXTCOL;
    if (/^robe/i.test(label)) return ROBE;
    if (/sweatshirt/i.test(label)) return SWEAT;
    var all = {}; [ROBE, SWEAT, TEXTCOL].forEach(function (m) { for (var k in m) all[k] = m[k]; }); return all;
  }
  var PER_GIRL = ['her name', 'her role', 'robe size', 'sweatshirt size', 'your letter', 'photo for', 'tray caption', 'clutch photo', 'clutch text', 'compact text'];

  function labelOf(field) {
    var el = field.querySelector('.prdf__label > span, .prdf__swlabel');
    return el ? el.textContent.replace(/required/i, '').trim() : '';
  }
  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }
  /* the 6 "Font Style" choices, same fonts + sizes as the satin robe page (pr-main-product1); fonts load in bbox-pdp-top */
  var FONTS = {
    'Elegant Script': { css: "font-family:'Great Vibes',cursive;font-size:22px", lid: '1.45em' },
    'Modern Script': { css: "font-family:'Dancing Script',cursive;font-weight:600;font-size:18px", lid: '1.2em' },
    'Classic Italic': { css: "font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:18px", lid: '1.1em' },
    'Bold Serif': { css: "font-family:'Playfair Display',Georgia,serif;font-weight:700;font-size:16px", lid: '1em' },
    'Modern Sans': { css: "font-family:'Montserrat',sans-serif;font-weight:500;font-size:13px;letter-spacing:.1em;text-transform:uppercase", lid: '.8em' },
    'Monogram Caps': { css: "font-family:'Cinzel',serif;font-weight:600;font-size:11px;letter-spacing:.04em;text-transform:uppercase", lid: '.78em' }
  };
  function fontCss(name, lid) { var f = FONTS[name]; return f ? f.css.replace(/font-size:[^;]+/, 'font-size:' + (lid ? f.lid : f.css.match(/font-size:([^;]+)/)[1])) : ''; }
  var SCROLL = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  /* 1. choice buttons + colour dots */
  function enhance(root) {
    root.querySelectorAll('.prdf__field').forEach(function (field) {
      if (field.dataset.bbx) return;
      var wrap = field.querySelector('.prdf__selectwrap'), sel = wrap && wrap.querySelector('select');
      if (!sel) return;
      var label = labelOf(field), opts = [].slice.call(sel.options).filter(function (o) { return o.value !== ''; });
      var swatch = /colou?r/i.test(label), font = /^font style$/i.test(label), choices = !swatch && !font && opts.length > 0 && opts.length <= 3;
      var COLORS = colorsFor(label);
      if (!swatch && !choices && !font) return;
      field.dataset.bbx = swatch ? 'swatch' : font ? 'font' : 'choice';
      field.classList.add('bbx-full');
      var box = document.createElement('div');
      box.className = swatch ? 'bbx-swatches' : font ? 'bbx-fonts' : 'bbx-choices';
      box.setAttribute('role', 'group'); box.setAttribute('aria-label', label);
      var name = null;
      opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = swatch ? 'bbx-sw' : font ? 'bbx-font' : 'bbx-choice'; b.dataset.value = o.value;
        if (swatch) { b.setAttribute('aria-label', o.value); b.title = o.value; b.style.background = COLORS[o.value] || '#ddd'; }
        else { b.textContent = o.value; if (font) b.style.cssText = fontCss(o.value); }
        b.addEventListener('click', function () { sel.value = o.value; fire(sel, 'change'); });
        box.appendChild(b);
      });
      if (swatch) { name = document.createElement('span'); name.className = 'bbx-sw-name'; box.appendChild(name); }
      function sync() {
        box.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.value === sel.value ? 'true' : 'false'); });
        if (name) name.textContent = sel.value || '';
      }
      sel.addEventListener('change', sync);
      wrap.classList.add('is-enhanced');
      wrap.parentNode.insertBefore(box, wrap.nextSibling);
      sync();
    });
  }

  /* 1b. neat rows: a half-width box with no visible half-width partner next to it takes the full row
     (headings and the lid preview end a pair; hidden conditional boxes don't count). Re-run on every change. */
  function tidy(root) {
    var grid = root.querySelector('.prdf__grid'); if (!grid) return;
    var kids = [].slice.call(grid.children), pending = null;
    kids.forEach(function (c) { if (c.dataset.bbxAuto) { c.classList.remove('bbx-full'); delete c.dataset.bbxAuto; } });
    function half(c) { return c.classList.contains('prdf__field--half') && !c.classList.contains('bbx-full'); }
    function flush() { if (pending) { pending.classList.add('bbx-full'); pending.dataset.bbxAuto = '1'; pending = null; } }
    kids.forEach(function (c) {
      if (!c.classList.contains('prdf__field')) { flush(); return; }
      if (c.hidden) return;
      // a box that appears only for a choice (e.g. "Her role, in your words") never pairs: its label height differs, so stack it full width
      if (c.hasAttribute('data-prdf-when-field') || c.hasAttribute('data-prdf-when')) { flush(); c.classList.add('bbx-full'); c.dataset.bbxAuto = '1'; return; }
      if (!half(c)) { flush(); return; }
      pending = pending ? null : c;
    });
    flush();
  }

  /* 1c. "What's inside": under the listing's photos on desktop, after the buy box on phones - the made-to-order form takes its old spot */
  function place() {
    var inside = document.querySelector('.bbx-inside'); if (!inside) return;
    inside.classList.add('bbx');
    var desk = window.matchMedia('(min-width: 750px)').matches;
    var media = document.querySelector('.product__media-wrapper'), buy = document.querySelector('[data-bbx-buy]');
    if (desk && media) {
      if (inside.parentNode !== media) media.appendChild(inside);
      if (media.classList.contains('product__column-sticky')) { media.classList.remove('product__column-sticky'); media.dataset.bbxUnstuck = '1'; }
    } else if (buy) {
      if (buy.nextElementSibling !== inside) buy.parentNode.insertBefore(inside, buy.nextSibling);
      if (media && media.dataset.bbxUnstuck) { media.classList.add('product__column-sticky'); delete media.dataset.bbxUnstuck; }
    }
    inside.classList.toggle('bbx-inside--media', !!(desk && media));
  }

  /* 2. lid preview */
  function lid(root) {
    if (!root.querySelector('[data-bbx-lid]')) return; // two cards: outside (under Her name) + inside (after the letter)
    var nameEl = root.querySelector('[data-bbx-lid-name]'), nameEls = root.querySelectorAll('[data-bbx-lid-name],[data-bbx-lid-name2]');
    var roleEls = root.querySelectorAll('[data-bbx-lid-role]'), letterEl = root.querySelector('[data-bbx-lid-letter]');
    var nameIn = null, roleSel = null, customIn = null, fontSel = null, letterIn = null, fromIn = null;
    root.querySelectorAll('.prdf__field').forEach(function (f) {
      var l = labelOf(f).toLowerCase();
      if (l === 'her name') nameIn = f.querySelector('input');
      if (l === 'her role') roleSel = f.querySelector('select');
      if (l.indexOf('her role,') === 0) customIn = f.querySelector('input'); // "Her role, in your words" (shown for Other)
      if (l === 'font style') fontSel = f.querySelector('select');
      if (l.indexOf('your letter') === 0) letterIn = f.querySelector('textarea');
      if (l.indexOf('sign it from') === 0) fromIn = f.querySelector('input');
    });
    function set(list, text) { for (var i = 0; i < list.length; i++) list[i].textContent = text; }
    function u() {
      if (nameIn) set(nameEls, nameIn.value.trim() || (nameIn.placeholder || 'Olivia').replace(/^e\.g\.\s*/i, ''));
      if (fontSel && nameEl) nameEl.style.cssText = fontCss(fontSel.value, true); // her name on the outside of the lid, in the chosen font
      if (roleSel) {
        var r = roleSel.value;
        if (r === 'Other' && customIn) r = customIn.value.trim();
        set(roleEls, r || 'Bridesmaid');
      }
      if (letterEl) { // inside of the lid: the letter (first line or so) + who signed it
        var t = letterIn ? letterIn.value.trim() : '', s = fromIn ? fromIn.value.trim() : '';
        if (t.length > 110) t = t.slice(0, 110).replace(/\s+\S*$/, '') + '…';
        letterEl.textContent = t + (t && s ? ' — ' + s : '');
        letterEl.hidden = !t;
      }
    }
    root.addEventListener('input', u); root.addEventListener('change', u); u();
  }

  /* 2b. "What's inside" tiles: larger preview instead of leaving for the item's product page */
  function zoom() {
    if (document.body.dataset.bbxZoomReady || !document.querySelector('[data-bbx-zoom]')) return;
    document.body.dataset.bbxZoomReady = '1'; // (not "bbxZoom": that attribute name is the tile hook)
    var ov = document.createElement('div'); ov.className = 'bbx-zoom'; ov.hidden = true; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = '<figure><button type="button" class="bbx-zoom__close" aria-label="Close">&times;</button><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(ov);
    var img = ov.querySelector('img'), cap = ov.querySelector('figcaption'), x = ov.querySelector('.bbx-zoom__close'), last = null;
    function close() { ov.hidden = true; document.documentElement.classList.remove('bbx-zoom-open'); if (last) { try { last.focus({ preventScroll: true }); } catch (e) { } } }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bbx-zoom]');
      if (b) { e.preventDefault(); last = b; img.src = b.getAttribute('data-bbx-zoom'); img.alt = b.getAttribute('data-bbx-cap') || ''; cap.textContent = img.alt; ov.hidden = false; document.documentElement.classList.add('bbx-zoom-open'); x.focus(); return; }
      if (!ov.hidden && (e.target === ov || e.target.closest('.bbx-zoom__close'))) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
  }

  /* 3. add & personalize the next bridesmaid */
  function next(buy, root) {
    var btn = buy.querySelector('[data-bbx-next]'), label = buy.querySelector('[data-bbx-next-label]'), toast = buy.querySelector('[data-bbx-toast]');
    var form = document.getElementById(buy.dataset.bbxForm); if (!btn || !form) return;
    var cartUrl = buy.dataset.bbxCart || '/cart';
    var added = 0, banner = null;
    function cartLink(text) { var a = document.createElement('a'); a.href = cartUrl; a.textContent = text; return a; }
    function say(msg, bad) {
      toast.textContent = msg; toast.classList.toggle('is-error', !!bad); toast.hidden = false;
      if (!bad) { toast.appendChild(document.createTextNode(' ')); toast.appendChild(cartLink('View cart')); }
    }
    function tell(who) { // the line the shopper lands on: right above the next girl's name field
      if (!banner) {
        banner = document.createElement('p'); banner.className = 'bbx-added'; banner.setAttribute('role', 'status');
        var grid = root.querySelector('.prdf__grid');
        if (grid) grid.parentNode.insertBefore(banner, grid); else root.appendChild(banner);
      }
      banner.textContent = '';
      var b = document.createElement('b'); b.textContent = (who ? who + "'s box" : 'Her box') + ' is in your cart'; banner.appendChild(b);
      banner.appendChild(document.createTextNode(added + ' added so far. Type the next name below, or '));
      banner.appendChild(cartLink('view your cart')); banner.appendChild(document.createTextNode('.'));
    }
    function valid() {
      var bad = [];
      root.querySelectorAll('.prdf__field[data-required]').forEach(function (f) {
        if (f.hidden) return;
        var c = f.querySelector('input:not([type=hidden]),select,textarea'); if (!c) return;
        var ok = c.type === 'file' ? !!(c.files && c.files.length) : c.value.trim().length > 0;
        f.classList.toggle('is-invalid', !ok); var x = f.querySelector('.prdf__fielderror'); if (x) x.hidden = ok;
        if (!ok) bad.push(f);
      });
      var er = root.querySelector('.prdf__error'); if (er) er.hidden = !bad.length;
      if (bad.length) { bad[0].scrollIntoView({ behavior: SCROLL, block: 'center' }); return false; }
      return true;
    }
    function clear() {
      var first = null;
      root.querySelectorAll('.prdf__field').forEach(function (f) {
        var l = labelOf(f).toLowerCase();
        if (!PER_GIRL.some(function (k) { return l.indexOf(k) === 0; })) return;
        f.querySelectorAll('input:not([type=hidden]),select,textarea').forEach(function (c) {
          if (c.type === 'file') { c.value = ''; fire(c, 'change'); }
          else { c.value = ''; fire(c, 'input'); fire(c, 'change'); }
          if (!first && c.type !== 'file') first = c;
        });
      });
      var to = banner || first;
      if (to) to.scrollIntoView({ behavior: SCROLL, block: 'start' });
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { } }
    }
    btn.addEventListener('click', function () {
      if (btn.disabled || !valid()) return;
      var nameIn = null; root.querySelectorAll('.prdf__field').forEach(function (f) { if (labelOf(f).toLowerCase() === 'her name') nameIn = f.querySelector('input'); });
      var who = nameIn && nameIn.value.trim();
      btn.disabled = true; label.textContent = 'Adding her box…';
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add the box.');
          added += 1;
          say((who ? who + "'s box" : 'Her box') + ' is in your cart (' + added + ' added). Her name, role and photo are cleared for the next girl; your picks stay.');
          tell(who);
          clear();
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
          }).catch(function () { });
        })
        .catch(function (e) { say(e.message || 'Could not add the box. Please try the Add to cart button.', true); })
        .then(function () { btn.disabled = false; label.textContent = '+ Add & personalize the next bridesmaid'; });
    });
  }

  /* 4. sticky phone bar */
  function sticky(buy, root) {
    var form = document.getElementById(buy.dataset.bbxForm); var real = form && (form.querySelector('button[name=add]') || document.querySelector('button[name=add][form="' + buy.dataset.bbxForm + '"]'));
    if (!real || document.querySelector('.bbx-float')) return;
    var price = buy.dataset.bbxPrice ? ' · ' + buy.dataset.bbxPrice : '';
    var bar = document.createElement('div'); bar.className = 'bbx-float';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'bbx-btn';
    var below = true;
    function paint() { b.textContent = (below ? 'Personalize her box' : 'Add to cart') + price; }
    b.addEventListener('click', function () {
      if (below) (root || form).scrollIntoView({ behavior: SCROLL, block: 'start' }); else real.click();
    });
    paint(); bar.appendChild(b); document.body.appendChild(bar);
    var ticking = false;
    function check() {
      ticking = false;
      var r = real.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      var nowBelow = (root || real).getBoundingClientRect().top > vh; // form still below the screen -> jump to it; otherwise submit
      if (nowBelow !== below) { below = nowBelow; paint(); }
      bar.classList.toggle('is-on', r.bottom < 0 || r.top > vh);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check); check();
  }

  /* the rating line scrolls to the Judge.me widget (its id changes per theme, so find it by class) */
  function reviewsLink() {
    var a = document.querySelector('.bbx-rate a'); if (!a || a.dataset.bbx) return; a.dataset.bbx = '1';
    a.addEventListener('click', function (e) {
      var w = document.querySelector('.jdgm-rev-widg, .jdgm-review-widget, [id$="__judgeme"]');
      if (w) { e.preventDefault(); w.scrollIntoView({ behavior: SCROLL, block: 'start' }); }
    });
  }

  function init() {
    reviewsLink();
    var root = document.querySelector('[data-prdf]'); var buy = document.querySelector('[data-bbx-buy]');
    if (root && !root.dataset.bbxReady) {
      root.dataset.bbxReady = '1'; enhance(root); tidy(root); lid(root);
      var t; root.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { tidy(root); }, 0); });
    }
    zoom(); place();
    if (!document.body.dataset.bbxPlace) { document.body.dataset.bbxPlace = '1'; var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(place, 150); }); }
    if (buy && root && !buy.dataset.bbxReady) { buy.dataset.bbxReady = '1'; next(buy, root); sticky(buy, root); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
